module.exports = __webpack_public_path__ + "static/media/gear.59316d53.svg";